import cx from 'classnames';

import './TaskContainer.scss';

export default function TaskContainer({ className, children }) {
  return <div className={cx('eds-task-container', className)}>{children}</div>;
}
